module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.woff2
// module id = ../../../../../src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.woff2
// module chunks = styles